import type { NodeData, TreeData } from '@antv/g6'

/**
 * 基准数据转换为原始数据
 */
export const treeDataToOriginData = (datum: TreeData) => {
  const copy = { ...datum }
  delete copy.depth
  delete copy.data
  delete copy.children
  return copy
}

/**
 * 树数据转换为图数据的节点数据
 */
export const treeDataToGraphNodeData = (datum: TreeData, depth: number) => {
  datum.depth = depth
  datum.data = treeDataToOriginData(datum)
  if (!datum.children) return datum as unknown as NodeData
  const { children, ...restDatum } = datum
  return { ...restDatum, children: children.map(child => child.id) } as NodeData
}
